import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Dossiers } from './pages/Dossiers';
import { DossierDetail } from './pages/DossierDetail';
import { Assessments } from './pages/Assessments';
import { NewScan } from './pages/NewScan';
import { Chat } from './pages/Chat';
import { Markets } from './pages/Markets';
import { Policies } from './pages/Policies';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mluairb8hvuc">
      <Routes data-id="element-1" data-mp="2mmcbu2cr7094">
        <Route element={<Layout data-id="element-3" data-mp="2mn5f2tci77mi" />} data-id="element-2" data-mp="2mmvlyww5wkcl">
          <Route path="/" element={<Navigate to="/dossiers" replace data-id="element-5" data-mp="31aqeoda66opo" />} data-id="element-4" data-mp="2mjpvpebsrcfa" />
          <Route path="/dossiers" element={<Dossiers data-id="element-7" data-mp="31cjmvx0flgzs" />} data-id="element-6" data-mp="31bianp7oiogh" />
          <Route path="/dossiers/:id" element={<DossierDetail data-id="element-9" data-mp="2wj8ehrfz0s5r" />} data-id="element-8" data-mp="2wka02pum4x1q" />
          <Route path="/assessments" element={<Assessments data-id="element-11" data-mp="28tw5osok2m3z" />} data-id="element-10" data-mp="2whxabqim5ie4" />
          <Route path="/new-scan" element={<NewScan data-id="element-13" data-mp="28sb9kymlev40" />} data-id="element-12" data-mp="28t4lee0esat0" />
          <Route path="/chat" element={<Chat data-id="element-15" data-mp="23u9t8lgjx9w8" />} data-id="element-14" data-mp="23vkw8j26adma" />
          <Route path="/markets" element={<Markets data-id="element-17" data-mp="23ti7018ugoim" />} data-id="element-16" data-mp="23utby4e102bb" />
          <Route path="/policies" element={<Policies data-id="element-19" data-mp="3ij66mgga9xb1" />} data-id="element-18" data-mp="3ikh8ubu2yx01" />
          <Route path="*" element={<Navigate to="/dossiers" replace data-id="element-21" data-mp="3mlj98vzqhf3l" />} data-id="element-20" data-mp="3ihv22ef0kliv" />
        </Route>
      </Routes>
    </BrowserRouter>;
}